import { render, staticRenderFns } from "./AdvisorCard.vue?vue&type=template&id=2adadeb4"
import script from "./AdvisorCard.vue?vue&type=script&lang=ts"
export * from "./AdvisorCard.vue?vue&type=script&lang=ts"
import style0 from "./AdvisorCard.vue?vue&type=style&index=0&id=2adadeb4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports